import React from 'react';
import { Link } from 'react-router-dom';
import { news } from '../../data/home';
import { ArrowButton } from '../ui/ArrowButton';
export function News() {
  return <section className="w-full bg-canvas py-24" data-id="element-131" data-mp="1s2ozhrh57nc4">
      <div className="mx-auto max-w-[1320px] px-6" data-id="element-132" data-mp="1day3vu0s09dv">
        <div className="flex flex-col justify-between gap-6 md:flex-row md:items-end" data-id="element-133" data-mp="1ib2pfygjjuay">
          <h2 className="font-display text-[52px] text-ink md:text-[64px]" data-id="element-134" data-mp="1i8pwkq98vzj4">Actualités</h2>
          <ArrowButton to="/la-banque/actualites" variant="outline" data-id="element-135" data-mp="14de3enaqmh4b">
            Toutes les actualités
          </ArrowButton>
        </div>
        <div className="mt-12 grid gap-px overflow-hidden rounded-[28px] bg-ink/10 md:grid-cols-3" data-id="element-136" data-mp="udn6keypfq12">
          {news.map(n => <Link key={n.title} to={n.path} className="group flex flex-col bg-canvas p-8 transition-colors hover:bg-white" data-id="element-137" data-mp="zczuz458555r">
              <div className="flex items-center gap-3 text-[13px]" data-id="element-138" data-mp="2op1yn2f6u1jz">
                <span className="rounded-full bg-brand-light px-3 py-1 font-medium text-brand" data-id="element-139" data-mp="2towr3aem2z75">{n.category}</span>
                <time className="text-ink-muted" data-id="element-140" data-mp="2ul0loq84jywp">{n.date}</time>
              </div>
              <h3 className="mt-6 text-[20px] font-semibold leading-snug text-ink" data-id="element-141" data-mp="2pmpe6m5ay0hn">{n.title}</h3>
              <span className="mt-auto pt-10 text-[14px] font-medium text-brand underline-offset-4 group-hover:underline" data-id="element-142" data-mp="33dlt5a6b2j68">
                Lire l’article
              </span>
            </Link>)}
        </div>
      </div>
    </section>;
}